<script>
    import PostCard from '../components/PostCard.svelte'
    import AddressForm from '../components/AddressForm.svelte'
    import {slide} from 'svelte/transition'
    import FaShippingFast from 'svelte-icons/fa/FaShippingFast.svelte'
    import Banner from '../components/Banner.svelte'
    import QueryString from 'query-string'
    import firebase from 'firebase/app'
    import {cartStore} from '../model/stores'
    import {emitHttpExceptionEvent, emitPageViewEvent} from '../actions/pageAnalytics'

    window.scrollTo(0, 0)
    export let location
    emitPageViewEvent(location, 'ThankYou')

    const queryParams = QueryString.parse(location.search)
    let transactionId = queryParams.transactionId
    let estimatedDeliveryDate = queryParams.estimatedDeliveryDate
    let sessionId = queryParams.session_id
    if (!transactionId && sessionId) {
        const getTransaction = firebase.functions().httpsCallable('getTransaction')
        getTransaction({stripeSessionId: sessionId}).then(res => {
            transactionId = res.data.transactionId
            estimatedDeliveryDate = res.data.estimatedDeliveryDate
            firebase.analytics().logEvent('purchase', {
                currency: 'USD',
                payment_type: 'free',
                value: 0,
                transaction_id: res.data.transactionId,
                sessionId: sessionId
            })
        }).catch(emitHttpExceptionEvent)
    }
    if (transactionId || sessionId) {
        cartStore.set([])
    }
    firebase.analytics().logEvent('checkout_progress', {
        checkout_option: 'end',
        sessionId: sessionId,
        transactionId: transactionId
    })
</script>

<style>


</style>
<svelte:head>
    <title>Thank you for using Post A Note!</title>
</svelte:head>
<div class="flex flex-column relative" transition:slide>
    <div class="pageContent flex flex-column mt2 mb4 self-center items-center">
        <Banner cl='success self-stretch'><b>Order processed!</b></Banner>

        <h1 class='mt4'>Thank you!</h1>
        <h4 class='center'>Your message will be delivered soon! <span class='icon mr1'><FaShippingFast/></span></h4>
        <hr class='mt4'>
        {#if transactionId}
            <div class="my3 flex flex-column items-center">
                <h4>Save this order ID for future reference:</h4>
                <h4 class='code mt1 mb1 '>{transactionId}</h4>
                <h4>It will help if we ever need customer support.</h4>
                <!--            {#if estimatedDeliveryDate}-->
                <!--                <h4 class='mt1'>Estimated Delivery Date: <b>{estimatedDeliveryDate}</b></h4>-->
                <!--            {/if}-->
            </div>

        {/if}
        <Banner cl='warning mt1'>
            Due to COVID-19, USPS has increased their shipping estimates from <b>1-3</b> Business days to <b>2-4</b>
            business days.
            <a style='color:#975A16' href='https://postalpro.usps.com/node/8016' title='USPS Covid-19 statement'>Learn more</a><br><br>
            Thank you for your understanding. ❤️
        </Banner>
    </div>
</div>
